import { Tag } from 'antd';
import type { LeadPriority, LeadStatus } from '@/core/types/lead';

const statusConfig: Record<LeadStatus, { label: string; color: string }> = {
  new: { label: 'جدید', color: 'blue' },
  working: { label: 'در حال پیگیری', color: 'processing' },
  qualified: { label: 'واجد شرایط', color: 'cyan' },
  converted: { label: 'تبدیل‌شده', color: 'success' },
  disqualified: { label: 'ردشده', color: 'error' },
  archived: { label: 'بایگانی', color: 'default' },
};

const priorityConfig: Record<LeadPriority, { label: string; color: string }> = {
  low: { label: 'کم', color: 'default' },
  normal: { label: 'عادی', color: 'blue' },
  high: { label: 'بالا', color: 'orange' },
  urgent: { label: 'فوری', color: 'red' },
};

export const LeadStatusTag = ({ status }: { status: LeadStatus }): React.ReactElement => {
  const config = statusConfig[status];
  return <Tag color={config.color}>{config.label}</Tag>;
};

export const LeadPriorityTag = ({ priority }: { priority: LeadPriority }): React.ReactElement => {
  const config = priorityConfig[priority];
  return <Tag color={config.color}>{config.label}</Tag>;
};

export const getStatusLabel = (status: LeadStatus): string => statusConfig[status].label;
export const getPriorityLabel = (priority: LeadPriority): string => priorityConfig[priority].label;
